import type { Product } from "@/store/types";

function fmtPrice(val: number | string | null | undefined): string | null {
  if (val === null || val === undefined) return null;
  const n = parseFloat(String(val));
  return isNaN(n) ? null : "$" + n.toFixed(2);
}

/**
 * Shows the single price relevant to the viewer: members see the member price,
 * non-members see the standard price. Falls back to the other price if the
 * preferred one is missing; renders nothing if neither is set.
 */
export default function PriceTag({ product, isMember }: { product: Product; isMember: boolean }) {
  const memberPrice = fmtPrice(product.Member);
  const standardPrice = fmtPrice(product.Standard);

  const price = isMember ? (memberPrice ?? standardPrice) : (standardPrice ?? memberPrice);
  if (!price) return null;

  const label = isMember ? "member" : "standard";

  return (
    <div className="agd:mb-3 agd:flex agd:flex-wrap agd:items-baseline agd:gap-2">
      <span className="agd:flex agd:items-baseline agd:gap-1">
        <span className="agd:text-lg agd:font-bold agd:text-primary">{price}</span>
        <span className="agd:text-[0.7rem] agd:text-muted-foreground">{label}</span>
      </span>
    </div>
  );
}
